import { render, staticRenderFns } from "./AddictiveStuffForm.vue?vue&type=template&id=d86ad6f4&"
import script from "./AddictiveStuffForm.vue?vue&type=script&lang=js&"
export * from "./AddictiveStuffForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports